import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface httpOptions {
  loading?: boolean;
  keepLoading?: boolean;
  header?: HttpHeaders;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiEndpoint: string = environment.apiUrl;
  version: string = environment.apiVersion;
  defaultOptions: httpOptions = {
    loading: true,
    keepLoading: false
  }

  constructor(private http: HttpClient) { }

  makeOptions(options?: httpOptions) {
    return Object.assign({}, this.defaultOptions, options);
  }

  get(url: string, params?: any, options?: httpOptions) {
    const getRequest = this.http.get(`${this.apiEndpoint}/${this.version}/${url}`, { params: params });
    return this.request(getRequest, options);
  }

  post(url: string, data?: any, options?: httpOptions) {
    const ops = {
      headers: options?.header
    }
    const postRequest = this.http.post(`${this.apiEndpoint}/${this.version}/${url}`, data, ops);
    return this.request(postRequest, options);
  }

  put(url: string, data?: any, options?: httpOptions) {
    const putRequest = this.http.put(`${this.apiEndpoint}/${this.version}/${url}`, data);
    return this.request(putRequest, options);
  }

  patch(url: string, data?: any, options?: httpOptions) {
    const patchRequest = this.http.patch(`${this.apiEndpoint}/${this.version}/${url}`, data);
    return this.request(patchRequest, options);
  }

  delete(url: string, options?: httpOptions, data?: any) {
    const deleteRequest = this.http.delete(`${this.apiEndpoint}/${this.version}/${url}`, { body: data });
    return this.request(deleteRequest, options);
  }

  request(request: Observable<any>, options?: httpOptions) {
    this.makeOptions(options);
    return request.pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
